module.exports = __webpack_public_path__ + "29701aa7c72b39b0ac0b6191f5beb1fd.jpg";